import { isTauri } from '@4players/odin-plugin-tauri/platform';
import { activeSpace } from '../app/shared/helpers/spaces';
import { backendEndpoints } from './backend-endpoints';

export const config = {
  productionMode: true,
  showFeedbackButton: true,
  showTestComponents: true,
  persistAppState: false,
  suppressLogging: false,
  enforceWebrtcTransport: false,
  ...backendEndpoints(location, undefined, isTauri ? activeSpace() : undefined),
  // See `environment.ts`.
  localSpaceServer: null,
  // See `environment.ts`.
  exposeDevTools: true,
};
